<template>
  <b-container>
     <b-card>
      <FormIncident :id="id"></FormIncident>

      <div class="mt-1 mb-2">
        <div class="flex justify-end">
          <b-button
            v-permission="`incident_form.handling`"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mt-1 mr-1 float-right"
            @click="handlingForm()">
              {{$t('handling_form')}}
          </b-button>
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="outline-secondary"
            class="mt-1 mr-1 float-right"
            @click="$router.push('/incident-form')">
              {{$t('back')}}
          </b-button>
        </div>
      </div>
     </b-card>
  </b-container>
</template>

<script>

import {
  BContainer,
  BRow,
  BCol,
  BCard,
  BTable,
  BButton,
  VBTooltip
} from 'bootstrap-vue'

import FormIncident from './FormIncident'

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    FormIncident,
    BContainer,
    BCard,
    BRow,
    BCol,
    BButton,
    BTable,
  },
  props: {
    id: {
      type: Number,
      default: null
    }
  },
  data: () => ({
    id: null,
    services: {

    },
  }),
  methods: {
    handlingForm() {
      this.$router.push(`/incident-form/${this.id}/handling`)
    },
  },
  mounted() {

  },
  beforeMount() {

  }
}
</script>
